import { Place } from '../models';
import { HttpService } from './http';
export class GeocoderService {
  static async autocomplete(input, {
    center,
    nbResults
  }, callback) {
    try {
      const body = [{
        key: 'input',
        value: input
      }, {
        key: 'result_size',
        value: nbResults || 5
      }];
      if (center) {
        body.push({
          key: 'latitude',
          value: center.lat
        }, {
          key: 'longitude',
          value: center.lng
        });
      }
      const data = await HttpService.get('v2', '/geocoder/autocomplete', body);
      const places = data.filter(res => res && res.location).map(parseAutocompleteResult);
      if (callback) callback(places);
      return places;
    } catch (err) {
      console.error('[GeocoderService][autocomplete]', err);
      if (callback) callback([]);
      return [];
    }
  }
  static async reverseGeocode(id, requestedLocation, callback) {
    const {
      coordinates: [lng, lat]
    } = requestedLocation;
    if (!lng || !lat) throw new Error('Location is not defined');
    try {
      const data = await HttpService.get('v2', '/geocoder/reverse', [{
        key: 'latitude',
        value: lat
      }, {
        key: 'longitude',
        value: lng
      }]);
      const place = parseReverseGeocodeResult({
        id,
        requestedLocation,
        ...data
      });
      callback?.(place);
      return place;
    } catch (err) {
      console.error('[GeocoderService][reverseGeocode]', err);
      throw err;
    }
  }
}
const autocompleteResultTypes = {
  hotel: 'hotel',
  restaurant: 'restaurant',
  fast_food: 'fastFood',
  park: 'garden',
  toilets: 'toilets',
  drinking_water: 'drinkingWater',
  charging_station: 'chargingStation',
  compressed_air: 'bicyclePump',
  bicycle: 'bicycleRepair',
  bicycle_parking: 'bicycleParking',
  train_station: 'trainStation',
  bus_stop: 'busStop',
  bus_station: 'busStop',
  tram_stop: 'tramStop',
  information: 'information',
  picnic_table: 'picnic',
  viewpoint: 'viewPoint',
  museum: 'museum',
  beach: 'beach',
  camp_site: 'camping',
  castle: 'castle',
  hostel: 'collective',
  castle_wall: 'fortification',
  ruins: 'ruins',
  fountain: 'fountain',
  monument: 'smallHeritage',
  place_of_worship: 'religious',
  industrial: 'industry',
  sports_centre: 'sport',
  stadium: 'sport',
  city: 'city',
  town: 'town'
};
function parseAutocompleteResult({
  main_text: primaryText,
  secondary_text: secondaryText,
  city,
  location: [lat, lng],
  osm_id,
  osm_key,
  osm_value,
  country,
  country_code
}) {
  return new Place(osm_id, {
    type: 'Point',
    coordinates: [lng, lat]
  }, {
    primaryText: primaryText.replace(/\n/g, ' '),
    secondaryText: secondaryText.replace(/\n/g, ' '),
    city: osm_value === 'town' ? primaryText.replace(/\n/g, ' ') : city,
    country: country,
    countryCode: country_code
  }, undefined, (osm_key === 'railway' && (osm_value === 'station' || osm_value === 'halt') ? 'trainStation' : autocompleteResultTypes[osm_value]) || undefined);
}
function parseReverseGeocodeResult({
  id,
  title,
  address,
  streetNumber,
  streetName,
  city,
  country,
  location,
  requestedLocation
}) {
  let primaryText;
  if (streetName) primaryText = streetNumber ? `${streetNumber}, ${streetName}` : streetName;else if (title) primaryText = title;else if (address) primaryText = address;
  if (!primaryText) throw new Error('invalid result');
  let secondaryText;
  if (streetName || title) secondaryText = city && country ? `${city}, ${country}` : city || country || undefined;
  return new Place(id, location || requestedLocation, primaryText ? {
    primaryText,
    secondaryText,
    city: city || undefined
  } : undefined);
}